/* Caddie for Zanetta Sg: product page. Loaded by the product and cart sections only.
   Gallery (swipe, arrows, thumbnails), colour and size picker with sold-out sizes, add to cart into
   the drawer, sticky add bar on phones, quantity steppers. Without it the plain variant select
   and form still post to Shopify. */
(function () {
  'use strict';
  function boot() {
    var Z = window.ZT || null;
    var S = (window.theme && window.theme.strings) || {};
    function $(s, r) { return (r || document).querySelector(s); }
    function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
    function fill(str, map) { return String(str || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); }
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---------- gallery ---------- */
    $$('[data-gallery]').forEach(function (g) {
      if (g._gal) return; g._gal = true;
      var track = $('[data-gal-track]', g), slides = $$('.gal-slide', g), thumbs = $$('[data-gal-thumb]', g), n = $('[data-gal-n]', g);
      var cur = 0;
      function mark(i) {
        cur = i;
        if (n) n.textContent = i + 1;
        thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        var t = thumbs[i]; if (t && t.parentElement && t.parentElement.parentElement) {
          var list = t.parentElement.parentElement, l = t.parentElement.offsetLeft;
          if (l < list.scrollLeft || l + t.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollTo({ left: l - 8, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      function go(i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce || instant ? 'auto' : 'smooth' });
        mark(i);
      }
      g._go = go;
      g._goMedia = function (id, instant) { var s = slides.filter(function (x) { return x.getAttribute('data-media-id') === String(id); })[0]; if (s) go(slides.indexOf(s), instant); };
      /* v1.12.0: from 768px the photos are a two-across grid (no sliding), so a colour change moves that colour's photo first */
      if (g.classList.contains('gal--grid')) {
        var wideMq = window.matchMedia('(min-width: 768px)'), slideGo = g._goMedia;
        g._goMedia = function (id, instant) {
          if (!wideMq.matches) return slideGo(id, instant);
          var s = slides.filter(function (x) { return x.getAttribute('data-media-id') === String(id); })[0];
          if (s && track.firstElementChild !== s) track.insertBefore(s, track.firstElementChild);
        };
      }
      if ('IntersectionObserver' in window && slides.length > 1) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) mark(slides.indexOf(e.target)); });
        }, { root: track, threshold: [0.61] });
        slides.forEach(function (s) { io.observe(s); });
      }
      g.addEventListener('click', function (e) {
        var st = e.target.closest('[data-gal-step]');
        if (st) { var d = parseInt(st.getAttribute('data-gal-step'), 10); go(cur + d < 0 ? slides.length - 1 : (cur + d >= slides.length ? 0 : cur + d)); return; }
        var th = e.target.closest('[data-gal-thumb]');
        if (th) go(parseInt(th.getAttribute('data-gal-thumb'), 10));
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      });
    });

    /* ---------- picker + add to cart ---------- */
    $$('[data-product-form]').forEach(function (root) {
      if (root._pf) return; root._pf = true;
      var dataEl = $('script[data-variants]', root); if (!dataEl) return;
      var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var groups = $$('[data-option]', root);
      var form = $('form.pdp-buy', root); if (!form) return;
      var idInput = $('[data-id-input]', form), btn = $('[data-add-button]', form);
      var priceEl = $('[data-price-wrap]', root), stock = $('[data-stock]', form);
      var fallback = $('select[data-fallback]', form);
      var gallery = $('[data-gallery]');
      var satc = $('[data-satc]'), satcSel = satc && $('[data-satc-sel]', satc), satcBtn = satc && $('[data-satc-btn]', satc);
      var single = !groups.length;
      if (!single) {
        if (fallback) { fallback.disabled = true; }
        if (idInput) idInput.disabled = false;
      }
      var kinds = groups.map(function (g) { return g.getAttribute('data-kind'); });
      var sizeG = groups[kinds.indexOf('size')], colourG = groups[kinds.indexOf('colour')];
      function selected() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
      function matches(v, opts) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); }
      function find(opts) { return opts.indexOf(null) > -1 ? null : variants.filter(function (v) { return matches(v, opts); })[0]; }

      /* start from the size this shopper picked before, if it is in stock in the shown colour */
      if (sizeG && !$('input:checked', sizeG)) {
        var mine = Z ? Z.Size.get() : '';
        var test = selected(); test[groups.indexOf(sizeG)] = mine;
        var hit = mine && variants.filter(function (v) { return matches(v, test) && v.available; })[0];
        var inp = hit && $$('input', sizeG).filter(function (i) { return i.value === mine; })[0];
        if (inp) inp.checked = true;
      }

      /* v1.7.0 pair offer box (snippets/pair-offer was removed in v1.19.0, so pof is null and paintOffer does nothing; kept so an older template still works) */
      var pof = $('[data-pair-offer]', root), OF = (window.theme && window.theme.offer) || {};
      function paintOffer(price) {
        if (!pof || !Z || !Z.Offer || String(price) === pof.getAttribute('data-price')) return;
        pof.setAttribute('data-price', price);
        var set = function (sel, txt) { var el = $(sel, pof); if (el) el.textContent = txt; };
        var t1 = Z.Offer.tier(price, 1, OF.p1), t2 = Z.Offer.tier(price, OF.n2, OF.p2);
        set('[data-pof-pay="1"]', Z.money(t1.pay));
        set('[data-pof-sub="1"]', fill(S.offer_tier1_sub, { pct: OF.p1, save: Z.money(t1.save) }));
        set('[data-pof-pay="2"]', Z.money(t2.pay));
        set('[data-pof-sub="2"]', fill(S.offer_tier2_sub, { pct: OF.p2, save: Z.money(t2.save) }));
      }

      var lastColour = colourG ? (($('input:checked', colourG) || {}).value) : null;
      function state() {
        var opts = selected(), v = find(opts);
        return { opts: opts, v: v, sizeMissing: !!(sizeG && !$('input:checked', sizeG)) };
      }
      function sync(fromUser) {
        var st = state(), opts = st.opts, v = st.v;
        groups.forEach(function (g, gi) {
          $$('input', g).forEach(function (inp) {
            var t = opts.slice(); t[gi] = inp.value;
            var ok = variants.some(function (x) { return matches(x, t) && x.available; });
            inp.classList.toggle('is-out', !ok);
            var sr = inp.nextElementSibling && $('[data-out]', inp.nextElementSibling); if (sr) sr.hidden = ok;
          });
          var cur = $('[data-current]', g), c = $('input:checked', g);
          if (cur) cur.textContent = c ? c.value : '';
        });
        if (idInput) idInput.value = v ? v.id : '';
        var label, can = false, msg = '';
        if (single) { can = btn ? !btn.disabled : false; label = btn ? btn.textContent : ''; }
        else if (st.sizeMissing) { label = S.choose_size; can = true; }
        else if (!v) { label = S.unavailable; }
        else if (!v.available) {
          label = S.sold_out;
          var colour = colourG ? opts[groups.indexOf(colourG)] : '';
          msg = sizeG ? fill(S.size_sold_out_msg, { size: opts[groups.indexOf(sizeG)], colour: colour }).replace(' in .', '.') : S.sold_out;
        } else { label = S.add; can = true; }
        if (btn && !single) {
          btn.textContent = label;
          if (v && !v.available) btn.setAttribute('disabled', ''); else btn.removeAttribute('disabled');
        }
        if (stock) stock.textContent = msg;
        root.setAttribute('data-available', v ? String(v.available) : '');
        var shown = v || variants.filter(function (x) { return matches(x, opts) && x.available; })[0] || variants.filter(function (x) { return matches(x, opts); })[0];
        if (shown && priceEl && shown.price_html) priceEl.innerHTML = shown.price_html;
        if (shown && shown.price != null) paintOffer(shown.price);
        if (v && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); }
        var colourNow = colourG ? opts[groups.indexOf(colourG)] : null;
        if ((fromUser === 'url' || (fromUser && colourNow !== lastColour)) && gallery && gallery._goMedia) {
          var withMedia = variants.filter(function (x) { return x.media && (colourG ? x.options[groups.indexOf(colourG)] === colourNow : true); })[0];
          if (withMedia) gallery._goMedia(withMedia.media, fromUser === 'url');
        }
        lastColour = colourNow;
        if (satcSel) {
          var tmp = document.createElement('div'); tmp.innerHTML = shown ? shown.price_html : '';
          satcSel.textContent = opts.filter(Boolean).concat([tmp.textContent.trim()]).filter(Boolean).join(' · ');
        }
        if (satcBtn) {
          satcBtn.textContent = label || S.add;
          if (v && !v.available) satcBtn.setAttribute('aria-disabled', 'true'); else satcBtn.removeAttribute('aria-disabled');
        }
        root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
        return can;
      }
      groups.forEach(function (g) {
        g.addEventListener('change', function (e) {
          if (g === sizeG && Z) Z.Size.set(e.target.value);
          sync(true);
        });
      });
      sync(/[?&]variant=/.test(location.search) ? 'url' : false);

      function askForSize() {
        if (!sizeG) return;
        if (stock) stock.textContent = S.pick_size_first;
        sizeG.classList.remove('is-asking'); void sizeG.offsetWidth; sizeG.classList.add('is-asking');
        sizeG.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        var first = $$('input', sizeG).filter(function (i) { return !i.classList.contains('is-out'); })[0] || $('input', sizeG);
        if (first) first.focus({ preventScroll: true });
      }

      form.addEventListener('submit', function (e) {
        if (!Z || !window.fetch || !window.FormData) return;
        e.preventDefault();
        var st = state();
        if (!single && st.sizeMissing) { askForSize(); return; }
        if (!single && (!st.v || !st.v.available)) return;
        var label = btn.textContent;
        btn.setAttribute('aria-busy', 'true'); btn.textContent = (S.adding || 'Adding') + '...';
        var title = ($('h1', root) || {}).textContent || '';
        var vid = idInput ? idInput.value : '';
        Z.Cart.add(new FormData(form)).then(function (j) {
          btn.textContent = label;
          if (Z.Cart.after) Z.Cart.after(btn, Z.addedId ? Z.addedId(j, vid) : vid); else Z.Cart.open(btn);
          Z.announce(fill(S.added, { title: title.trim() + (st.opts.length ? ', ' + st.opts.filter(Boolean).join(' / ') : '') }));
        }).catch(function (err) {
          btn.textContent = label;
          if (stock) stock.textContent = err.message || S.error;
        }).then(function () { btn.removeAttribute('aria-busy'); });
      });

      /* sticky add bar on phones, once the main button has scrolled away above. A scroll check, not an
         IntersectionObserver: a jump past the button (anchor, fast fling) crosses no threshold. */
      if (satc && btn) {
        var ticking = false, wasOn = false;
        var check = function () {
          ticking = false;
          var on = btn.getBoundingClientRect().bottom < 0;
          if (on === wasOn) return; wasOn = on;
          satc.classList.toggle('is-on', on);
          if (on) satc.removeAttribute('inert'); else satc.setAttribute('inert', '');
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
        check();
        satcBtn.addEventListener('click', function () {
          var st = state();
          if (!single && st.sizeMissing) { askForSize(); return; }
          if (!single && st.v && !st.v.available) { sizeG && sizeG.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); return; }
          if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
        });
      }
    });

    /* ---------- quantity steppers (product form, cart page) ---------- */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]'); if (!b) return;
      var input = $('input', b.closest('.qty')); if (!input) return;
      var min = parseInt(input.min || '0', 10), v = parseInt(input.value || '0', 10) + parseInt(b.getAttribute('data-qty'), 10);
      input.value = Math.max(min, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  if (window.ZT || !document.querySelector('[data-cart-open]')) boot(); else document.addEventListener('zt:ready', boot);
})();

/* v1.13.0: size guide, "I know my size in". Picking a system offers that system's values for this style (or a foot
   length in cm); the matching ZANETTA (EU) row is highlighted and named in words. Without JavaScript the table and
   the steps still show; the picker stays hidden. */
(function () {
  'use strict';
  function fill(s, m) { return String(s || '').replace(/\[(\w+)\]/g, function (a, k) { return m[k] != null ? m[k] : a; }); }
  function init(root) {
    if (root._sgx) return; root._sgx = true;
    var know = root.querySelector('[data-sgx-know]'); if (!know) return;
    var rows = [].slice.call(root.querySelectorAll('[data-sg-row]')); if (!rows.length) return;
    var pick = root.querySelector('[data-sgx-pick]'), sel = root.querySelector('[data-sgx-val]');
    var cmRow = root.querySelector('[data-sgx-cmrow]'), cm = root.querySelector('[data-sgx-cm]'), out = root.querySelector('[data-sgx-out]');
    know.hidden = false;
    function mark(row, msg) {
      rows.forEach(function (r) { r.classList.toggle('is-match', r === row); if (r === row) r.setAttribute('aria-current', 'true'); else r.removeAttribute('aria-current'); });
      out.textContent = row ? fill(root.getAttribute('data-result'), { size: row.getAttribute('data-eu') }) : (msg || '');
    }
    know.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-sgx-sys')) {
        var sys = t.value; mark(null);
        if (sys === 'cm') { pick.hidden = true; cmRow.hidden = false; cm.value = ''; return; }
        cmRow.hidden = true; pick.hidden = false;
        var opts = '<option value="">' + (root.getAttribute('data-choose') || '') + '</option>';
        rows.forEach(function (r, i) { var v = r.getAttribute('data-' + sys); if (v) opts += '<option value="' + i + '">' + v.replace(/</g, '&lt;') + '</option>'; });
        sel.innerHTML = opts; sel.value = '';
        return;
      }
      if (t === sel) mark(sel.value === '' ? null : rows[+sel.value]);
    });
    cm.addEventListener('input', function () {
      var raw = String(cm.value).replace(',', '.').trim();
      if (raw === '') { mark(null); return; }
      var v = Math.round(parseFloat(raw) * 10) / 10;
      if (isNaN(v)) { mark(null); return; }
      var hit = rows.filter(function (r) { return v >= parseFloat(r.getAttribute('data-from')) && v <= parseFloat(r.getAttribute('data-to')); })[0];
      if (hit) mark(hit);
      else mark(null, fill(root.getAttribute('data-range'), { min: rows[0].getAttribute('data-from'), max: rows[rows.length - 1].getAttribute('data-to') }));
    });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-sgx]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* v1.19.0 pair picker (option B, JJ 2026-10-15). "1 pair" (the default) leaves the product form exactly as before.
   "2 pairs" opens Pair 2 (style from this style + Our Picks, then colour, then size) and one Add to bag sends both
   pairs in ONE Cart AJAX call ({ items: [pair 1, pair 2] }), so the bag gets two lines; the bag's saving is still
   what Shopify reports. Prices here are the theme's integer-cent sums (snippets/pair-boxes.liquid): each pair's
   saving rounded half up. Shopify spreads an automatic discount over lines its own way, so with two different
   prices the checkout can differ by a cent. Without JavaScript the boxes do nothing and the form adds one pair. */
(function () {
  'use strict';
  function boot() {
    var Z = window.ZT; if (!Z) return;
    var TS = (window.theme && window.theme.strings) || {}, OF = (window.theme && window.theme.offer) || {};
    Array.prototype.forEach.call(document.querySelectorAll('script[data-pp-data]'), function (dataEl) {
      var root = dataEl.closest('[data-product-form]'); if (!root || root._pp) return; root._pp = true;
      var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var S = D.strings, P2 = +D.p2 || 0, fill = Z.fill, money = Z.money, esc = Z.esc;
      function $(s, r) { return (r || root).querySelector(s); }
      function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
      var V1; try { V1 = JSON.parse($('script[data-variants]').textContent); } catch (e) { return; }
      var groups = $$('[data-option]'), kinds = groups.map(function (g) { return g.getAttribute('data-kind'); });
      var form = $('form.pdp-buy'), btn = form && $('[data-add-button]', form); if (!form || !btn) return;
      var opts1 = $('.pdp-opts'), h1 = $('[data-pp-h1]'), box = $('[data-pp2]'); if (!box) return;
      var optsBox = $('[data-pp-opts]', box), ask = $('[data-pp-ask]', box), base = 'PP2-' + Math.random().toString(36).slice(2, 7) + '-';
      if (opts1 && h1) opts1.insertBefore(h1, opts1.firstChild);
      var mode = 1, ci = 0, col2 = null, size2 = null, started = false;

      function tier(price, pct) { price = Math.round(+price || 0); var s = Math.floor((price * pct + 50) / 100); return { full: price, save: s, pay: price - s }; }
      function until() { return Z.Offer && Z.Offer.until ? Z.Offer.until() : ''; }
      function sel1() { return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
      function match(v, o) { return v.options.every(function (x, i) { return o[i] == null || x === o[i]; }); }
      function v1() { var o = sel1(); return o.indexOf(null) > -1 ? null : V1.filter(function (v) { return match(v, o); })[0] || null; }
      function shown1() { return v1() || V1.filter(function (v) { return match(v, sel1()); })[0] || V1[0]; }
      function cand() { return D.cands[ci]; }
      function v2() {
        var c = cand(); if (c.si > -1 && !size2) return null;
        return c.variants.filter(function (v) { return (c.ci < 0 || v.options[c.ci] === col2) && (c.si < 0 || v.options[c.si] === size2); })[0] || null;
      }
      function shown2() { var c = cand(); return v2() || c.variants.filter(function (v) { return c.ci < 0 || v.options[c.ci] === col2; })[0] || c.variants[0]; }
      function sumOf(colour, size) { return [colour, size ? fill(S.size_short, { size: size }) : ''].filter(Boolean).join(', '); }

      /* Pair 2's colour, then size, whatever order the store gave the options in (Seville and Mallorca list Size first) */
      function renderOpts(focusId) {
        var c = cand(), h = '';
        [c.ci, c.si].filter(function (i) { return i > -1; }).forEach(function (oi) {
          var name = c.options[oi], vals = c.values[oi] || [];
          if (oi === c.ci) {
            var anyImg = c.variants.some(function (v) { return v.img; });
            h += '<fieldset class="opt opt--colour' + (anyImg ? ' has-sw' : '') + '"><legend><span class="opt-name">' + esc(name) + '</span><span class="sr">: </span><span class="opt-cur">' + esc(col2 || '') + '</span></legend><div class="opt-vals">';
            vals.forEach(function (val, k) {
              var id = base + 'c' + k, im = c.variants.filter(function (v) { return v.options[oi] === val && v.img; })[0];
              h += '<input type="radio" id="' + id + '" name="' + base + 'c" value="' + esc(val) + '" data-pp-c' + (val === col2 ? ' checked' : '') + '>' +
                '<label for="' + id + '"><span class="opt-sw" aria-hidden="true">' + (im ? '<img src="' + esc(im.img) + '" alt="" width="44" height="44">' : '') + '</span><span class="opt-v">' + esc(val) + '</span></label>';
            });
            h += '</div></fieldset>';
          } else {
            h += '<fieldset class="opt opt--size"><legend><span class="opt-name">' + esc(name) + '</span><span class="sr">: </span><span class="opt-cur">' + esc(size2 || '') + '</span></legend><div class="opt-vals size-grid">';
            vals.forEach(function (val, k) {
              var id = base + 's' + k;
              var ok = c.variants.some(function (v) { return v.options[oi] === val && (c.ci < 0 || v.options[c.ci] === col2) && v.available; });
              h += '<input type="radio" id="' + id + '" name="' + base + 's" value="' + esc(val) + '" data-pp-s' + (val === size2 ? ' checked' : '') + (ok ? '' : ' class="is-out"') + '>' +
                '<label for="' + id + '" class="size-chip"><span class="opt-v">' + esc(val) + '</span>' + (ok ? '' : '<span class="sr">, ' + esc(TS.sold_out || '') + '</span>') + '</label>';
            });
            h += '</div></fieldset>';
          }
        });
        optsBox.innerHTML = h;
        if (focusId) { var f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
      }

      /* from 768px the buy column is sticky (product.css). With two pairs open it can be taller than the screen, and a
         sticky box taller than the screen hides its own bottom (Add to bag) until the photos end. So when it does not
         fit, it sticks by its bottom edge (a negative top); when it fits, the theme's own top is back. */
      function fitSticky() {
        root.style.top = '';
        if (getComputedStyle(root).position !== 'sticky') return;
        var top = parseFloat(getComputedStyle(root).top) || 0, room = window.innerHeight - 16;
        if (top + root.offsetHeight > room) root.style.top = Math.round(room - root.offsetHeight) + 'px';
      }

      function paint() {
        var a = shown1(), p1 = a.price, u = until(), t1 = tier(p1, +OF.p1 || 0);
        var b = shown2(), tA = tier(p1, P2), tB = tier(b.price, P2);
        var b1p = $('[data-pp-box1-pay]'), b1s = $('[data-pp-box1-sub]'), b2p = $('[data-pp-box2-pay]'), b2s = $('[data-pp-box2-sub]');
        var oneOn = !!u && t1.save > 0;
        if (b1p) { b1p.textContent = money(oneOn ? t1.pay : p1); b1s.hidden = !oneOn; if (oneOn) b1s.textContent = fill(S.until, { date: u }); }
        if (b2p) {
          b2p.innerHTML = tA.pay === tB.pay
            ? esc(money(tA.pay)) + ' <span class="pp-a">' + esc(fill(S.a_pair, { price: '' }).trim()) + '</span>'
            : esc(money(tA.pay + tB.pay)) + ' <span class="pp-a">' + esc(S.in_total) + '</span>';
          b2s.textContent = fill(S.tier2_sub, { pct: P2, save: money(tA.save + tB.save) });
        }
        var duo = mode === 2;
        if (h1) h1.hidden = !duo;
        if (opts1) opts1.classList.toggle('pp-step', duo);
        box.hidden = !duo;
        var o1 = sel1(), cIdx = kinds.indexOf('colour'), sIdx = kinds.indexOf('size');
        var s1 = $('[data-pp-sum1]'); if (s1) s1.textContent = sumOf(cIdx > -1 ? o1[cIdx] : '', sIdx > -1 ? o1[sIdx] : '');
        var pr1 = $('[data-pp-price1]'); if (pr1) pr1.textContent = money(tA.pay);
        $('[data-pp-sum2]', box).textContent = sumOf(col2, size2);
        $('[data-pp-price2]', box).textContent = money(tB.pay);
        var sc = $('[data-pp-style-cur]'); if (sc) sc.textContent = cand().title;
        var tot = $('[data-pp-total]'), save = $('[data-pp-save]');
        if (tot) {
          tot.hidden = !duo;
          if (duo) {
            $('[data-pp-total-n]').textContent = S.pairs_two;
            $('[data-pp-total-p]').textContent = money(tA.pay + tB.pay) + ' ' + S.in_total;
            save.textContent = fill(S.save, { amount: money(tA.save + tB.save) });
          } else if (oneOn && v1()) {
            /* one pair: the saving line only once a size is chosen (brand-guardian, 2026-10-15) */
            save.textContent = fill(S.save_until, { amount: money(t1.save), date: u });
          } else save.textContent = '';
        }
        root.setAttribute('data-pp-pairs', String(mode));
        fitSticky();
      }

      function start() {
        if (started) return; started = true;
        var c = cand(), o1 = sel1(), cIdx = kinds.indexOf('colour'), sIdx = kinds.indexOf('size');
        var c1 = cIdx > -1 ? o1[cIdx] : null, s1 = sIdx > -1 ? o1[sIdx] : null;
        var cols = c.ci > -1 ? c.values[c.ci] : [];
        col2 = cols.filter(function (x) { return x !== c1; })[0] || cols[0] || null;
        size2 = s1 && c.si > -1 && c.values[c.si].indexOf(s1) > -1 ? s1 : null;
        renderOpts();
      }
      function setMode(m) { mode = m; if (m === 2) start(); ask.textContent = ''; paint(); }

      $$('input[name^="pp-mode-"]').forEach(function (r) { r.addEventListener('change', function () { setMode(+r.value); }); });
      $$('input[name^="pp-style-"]').forEach(function (r) {
        r.addEventListener('change', function () {
          ci = +r.value; var c = cand();
          var cols = c.ci > -1 ? c.values[c.ci] : [];
          if (cols.indexOf(col2) < 0) col2 = cols[0] || null;
          if (size2 && (c.si < 0 || c.values[c.si].indexOf(size2) < 0)) size2 = null;
          ask.textContent = ''; renderOpts(); paint();
        });
      });
      optsBox.addEventListener('change', function (e) {
        var t = e.target;
        if (t.hasAttribute('data-pp-c')) col2 = t.value;
        else if (t.hasAttribute('data-pp-s')) { size2 = t.value; ask.textContent = ''; }
        else return;
        renderOpts(t.id); paint();
      });
      root.addEventListener('variant:change', paint);
      window.addEventListener('resize', fitSticky);

      /* capture phase, so it runs before the form's own handler; one pair, or pair 1 without a size, falls through to it */
      document.addEventListener('submit', function (e) {
        if (e.target !== form || mode !== 2) return;
        var o = sel1(); if (o.indexOf(null) > -1) return;
        var a = v1(); if (!a || !a.available) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var b = v2();
        if (!b) {
          ask.textContent = S.pick_size;
          var sg = $('.opt--size', optsBox);
          if (sg) { sg.classList.remove('is-asking'); void sg.offsetWidth; sg.classList.add('is-asking'); sg.scrollIntoView({ block: 'center' }); var f = $('input', sg); if (f) f.focus({ preventScroll: true }); }
          return;
        }
        if (!b.available) return;
        var label = btn.textContent;
        btn.setAttribute('aria-busy', 'true'); btn.textContent = (TS.adding || 'Adding') + '...';
        Z.Cart.add({ items: [{ id: a.id, quantity: 1 }, { id: b.id, quantity: 1 }] }).then(function () {
          btn.textContent = label;
          Z.Cart.open(btn);
          var t1 = (($('h1') || {}).textContent || '').trim();
          Z.announce(fill(TS.added, { title: t1 }) + ' ' + fill(TS.added, { title: cand().title }));
        }).catch(function (err) {
          btn.textContent = label; ask.textContent = err.message || TS.error || '';
        }).then(function () { btn.removeAttribute('aria-busy'); });
      }, true);

      paint();
    });
  }
  if (window.ZT) boot(); else document.addEventListener('zt:ready', boot);
})();
